import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { tokens, typographyStyles } from '@fluentui-copilot/tokens';
import type { GhostTextSlots, GhostTextState } from './GhostText.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const ghostTextClassNames: SlotClassNames<GhostTextSlots> = {
  root: 'fai-GhostText',
  indicator: 'fai-GhostText__indicator',
};

/**
 * Styles for the root slot
 */
const useStyles = makeStyles({
  root: {
    color: tokens.colorNeutralForeground4,
    whiteSpace: 'pre-wrap',
    gap: tokens.spacingHorizontalXS,
  },

  indicator: {
    ...typographyStyles.caption2Strong,
    color: tokens.colorNeutralForeground3,
    backgroundColor: tokens.colorNeutralBackground5,
    padding: `${tokens.spacingVerticalNone} ${tokens.spacingHorizontalSNudge}`,
    borderRadius: tokens.borderRadiusSmall,
    marginLeft: tokens.spacingHorizontalXS,
    merginRight: tokens.spacingHorizontalXS,
  },
});

/**
 * Apply styling to the GhostText slots based on the state
 */
export const useGhostTextStyles_unstable = (state: GhostTextState): GhostTextState => {
  'use no memo';

  const styles = useStyles();
  state.root.className = mergeClasses(ghostTextClassNames.root, styles.root, state.root.className);

  if (state.indicator) {
    state.indicator.className = mergeClasses(
      ghostTextClassNames.indicator,
      styles.indicator,
      state.indicator.className,
    );
  }

  return state;
};
